import(/* webpackMode: "eager" */ "/home/ubuntu/download/6959ea267683ed001402a35f/secondhand_mobile_hub/src/app/error.tsx");
